import { FC } from 'react';

import { Box, Dropdown, DropdownItem } from '@base-app';
import { Icon, StyledSectionTitle, StyledTitle } from './SectionTitle.styles';
import { SectionTitleProps } from './SectionTitle.types';

const SectionTitle: FC<SectionTitleProps> = ({ css, handleClick, headerOptions, label, sub }) => {
  const handleSelect = (item: DropdownItem): void => {
    handleClick?.(item);
  };

  return (
    <StyledSectionTitle css={{ ...css }}>
      <Box css={{ display: 'flex' }}>
        <StyledTitle css={{ fontWeight: '$bold' }}>{label}</StyledTitle>
        {sub && <StyledTitle css={{ fontWeight: '$regular', marginLeft: '$2' }}>{sub}</StyledTitle>}
      </Box>
      {headerOptions && headerOptions.length > 0 && (
        <Dropdown id="card-grid-options" icon={<Icon />} items={headerOptions} onSelect={handleSelect} />
      )}
    </StyledSectionTitle>
  );
};

export default SectionTitle;
